import React from "react";

import Logout from "../../components/Logout";

const LogoutRoute = props => {
    return <Logout {...props}></Logout>;
};

export default LogoutRoute;
